import React from 'react';
import RewardHistorySection from './RewardHistorySection';
import { Box, Typography } from '@mui/material';

const RewardHistoryWidget = ({ history = [], loading = false }) => {
    return (
        <Box>
            <Typography variant="h4" fontWeight={800} sx={{ mb: 1, color: '#1b5e20', textAlign: 'center' }}>
                📜 Your Eco Rewards Timeline
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
                Track every point earned on your environmental journey
            </Typography>
            <RewardHistorySection history={history} loading={loading} />
        </Box>
    );
};

export default RewardHistoryWidget;
